<template>
<div class="CreateReport_warp">
    <div class="from_warp">
        <div class="form_box">
            <div class="row_box" v-for="(item, index) in infoData" :key="index">
                <p class="title_text">{{item.title}}</p>
                <van-field v-if="item.type === 'tel'" maxlength="11" v-model="item.inputValue" :type="item.type" :placeholder="item.placeholder" />
                <van-field v-else v-model="item.inputValue" :type="item.type" :placeholder="item.placeholder" />
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
        <div @click="getReport" class="btn_box">免费获取报告</div>
    </div>
    <div class="donwnload_pop_warp">
        <van-popup v-model="showPop">
            <div class="donwnload_box">
                <img class="down_img" :src="require('@/common/images/gujingimgs/icon_other.png')" alt="">
                <p>您已成功获取企业估值报告<br />点击下方按钮进行下载</p>
                <div @click="downloadPdf(pdfUrl)" class="btn">点击下载报告</div>
            </div>
        </van-popup>
    </div>
</div>
</template>

<script>
import {Toast} from 'vant'
import {dealSwEvOrderinfo, createCode} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'CreateReport',
    data() {
        return {
            pdfUrl: '', // 免费获取报告后 后台返回的pdf文件地址
            showPop: false, // 免费获取报告成功后下载报告弹窗
            infoData: [
                {
                    title: '公司名称：',
                    inputValue: '',
                    placeholder: '请填写正确的公司名称',
                    type: 'text'
                },
                {
                    title: '联系人：',
                    inputValue: '',
                    placeholder: '请填写联系人',
                    type: 'text'
                },
                {
                    title: '联系电话：',
                    inputValue: '',
                    placeholder: '请填写联系电话',
                    type: 'tel'
                },
                {
                    title: '职位：',
                    inputValue: '',
                    placeholder: '请填写您的职位',
                    type: 'text'
                }
            ],
            usercode: '', // (用户输入的验证码)
            codeEncryption: '', // 加密后的验证码
            authCodeImg: '' // 验证码图片
        }
    },
    mounted() {
        this.getAuthCode()
    },
    methods: {
        // 获取验证码
        getAuthCode() {
            this.setLoading(true)
            let params = {}
            createCode({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.authCodeImg = data.result.base64
                    this.codeEncryption = data.result.codeEncryption
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 下载报告
        downloadPdf(url) {
            this.showPop = false
            window.open(url)
        },
        // 免费获取报告
        getReport() {
            if (this.infoData[0].inputValue === '') {
                Toast('请填写公司名称')
                return
            }
            if (this.infoData[1].inputValue === '') {
                Toast('请填写联系人')
                return
            }
            if (this.infoData[2].inputValue === '') {
                Toast('请填写联系电话')
                return
            }
            if (!(/^1[3456789]\d{9}$/.test(this.infoData[2].inputValue))) {
                Toast('请填写正确的联系电话')
                return
            }
            if (this.infoData[3].inputValue === '') {
                Toast('请填写您的职位')
                return
            }
            if (this.usercode === '') {
                Toast('请填写验证码')
                return
            }
            this.setLoading(true)
            let params = {
                orderno: this.$route.query.orderno,
                companyname: this.infoData[0].inputValue,
                linkman: this.infoData[1].inputValue,
                linktel: this.infoData[2].inputValue,
                linkduty: this.infoData[3].inputValue,
                usercode: this.usercode,
                codeEncryption: this.codeEncryption
            }
            dealSwEvOrderinfo({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.pdfUrl = data.data.evreporturl
                    this.showPop = true
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.CreateReport_warp {
    padding: 0.32rem;
    padding-bottom: 0.88rem;
    .from_warp {
        background-color: #fff;
        padding: 0.32rem;
        padding-top: 0.02rem;
        .form_box {
            .row_box {
                border-bottom: 0.01rem solid #E5E5E5;
                padding-top: 0.3rem;
                padding-bottom: 0.12rem;
                .title_text {
                    color: #333;
                    font-size: 0.32rem;
                    line-height: 0.46rem;
                    padding-bottom: 0.08rem;
                    display: flex;
                    align-items: center;
                    &>img {
                        margin-left: 0.2rem;
                        width: 0.22rem;
                        height: 0.22rem;
                    }
                }
                .van-cell{
                    padding: 0.2rem 0;
                    font-size: 0.32rem;
                }
                .auth_code_img {
                    width: 1.6rem;
                    height: 0.68rem;
                }
            }
            .row_box:nth-last-of-type(1){
                border-bottom: none;
                padding-bottom: 0;
                .van-cell{
                    padding-bottom: 0;
                }
            }
        }
        .btn_box {
            font-size: 0.32rem;
            width: 100vw;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            position: fixed;
            bottom: 0;
            left: 0;
            background-color: #409EFF;
            color: #FFF;
        }
    }
    .donwnload_pop_warp {
        .van-popup{
            width: 5.6rem;
            border-radius: 0.1rem;
            overflow: hidden;
        }
        .donwnload_box {
            padding-top: 0.6rem;
            padding-bottom: 0.44rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .down_img {
                width: 3.51rem;
                min-width: 3.51rem;
                width: 3.51rem;
                min-height: 2.31rem;
            }
            &>p {
                font-size: 0.32rem;
                text-align: center;
                color: #333;
                line-height: 0.48rem;
                margin: 0.4rem 0;
            }
            .btn {
                width: 4.8rem;
                color: #fff;
                background-color: #409EFF;
                font-size: 0.32rem;
                line-height: 0.7rem;
                text-align: center;
                border-radius: 0.35rem;
            }
        }
    }
}
</style>